import { render, staticRenderFns } from "./MaterialesClaseDemo.vue?vue&type=template&id=389c4136&scoped=true"
import script from "./MaterialesClaseDemo.vue?vue&type=script&lang=js"
export * from "./MaterialesClaseDemo.vue?vue&type=script&lang=js"
import style0 from "./MaterialesClaseDemo.vue?vue&type=style&index=0&id=389c4136&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "389c4136",
  null
  
)

export default component.exports